import { z } from 'zod';

export const schemaConsorsEmail = z
    .string()
    .min(2)
    .max(40)
    .regex(/^[0-9a-zA-Z.+_-]{2,}@[0-9a-zA-Z]{1,}([0-9a-zA-Z._-]*[0-9a-zA-Z]+)*\.[a-zA-Z]{2,6}$/, 'Invalid characters');
